<template>
    <router-view/>
</template>

<style scoped>
@import url('./modules/assets/css/main.css');
</style>

<script></script>